import React, { useContext, useEffect, useState } from 'react';
import { Tabs, Tab, Nav, Modal, Button, Table, Form } from "react-bootstrap";
import settingw from "../../assets/setting-white.svg";
import docGrey from '../../assets/doc-grey.svg';
import downloadImg from "../../assets/download.svg";
import backImg from "../../assets/back.svg";
import deleteImageEnabled from '../../assets/reddelete.svg';
import { processType } from '../../utils/constant';
import {
    getRFQById,
    handleDeclineRFQ,
    submitRFQ,
    getRFQByRFQRefId,
    uploadRFQDocument,
    deleteRFQDocument,
} from '../../utils/actions/userActions'
import { Link, useNavigate, useParams, Redirect } from 'react-router-dom';
import { extractURLAndEncodedFilename, numberInputOnWheelPreventChange, validateUser } from '../../utils/helper';
import { toast } from 'react-toastify';
import moment from 'moment';
import fileSaver from "file-saver";
import HoverInfo from '../../component/HoverInfo/HoverInfo'
import { OrdersContext } from '../../context/orders.context';
import ChatButton from '../../component/Chat/ChatButton';
import Chat from "../../component/Chat";
import qs from 'query-string';
import CurrencyFormat from '../../component/CurrencyFormat';
import { Loading } from '../../component/Loading';
import { DeleteIcon, DownloadIcon } from '../../component/icons';


const RFQDetails = () => {
    const loggedInUserToken = localStorage.getItem("Token");
    const [isValidUser, setIsValidUser] = useState(true);
    const [selectedRFQ, setSelectedRFQ] = useState({});
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showReviewQuoteModal, setShowReviewQuoteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const { search, } = window.location;
    const param = qs.parse(search);
    const navigate = useNavigate();
    const [open, setOpen] = useState(param.chat);
    const { refresh, setRefresh, activeTab, setSelectedChatRefId, selectedChatRefId } = useContext(OrdersContext);
    const [showRedirectModal, setShowRedirectModal] = useState(false);
    let userId = localStorage.getItem('_id');
    let email = localStorage.getItem('email');

    const download = async (name, url) => {
        const data = extractURLAndEncodedFilename(url);
        let fileUrl = `${data.url}/${data.encodedFilename}`;
        fileSaver.saveAs(fileUrl, name);
    };


    useEffect(() => {
        let isLoggedInUser = validateUser(navigate);
        if (isLoggedInUser) {
            if (id) {
                setLoading(true);
                fetchData();
            }
        }
    }, [])

    const fetchData = async () => {
        try {
            const response = await getRFQByRFQRefId(id, loggedInUserToken);
            if (response.status) {
                setSelectedRFQ(response.data)
                if (response.data.status == 'Cancelled' || response.data.status == 'Active Order') {
                    setShowRedirectModal(true);
                }
            } else {
                toast.error("Quotation data not found.Please contact us at info@dainsta.com to resolve the issue.")
                navigate('/my-orders')
                return;
            }

            let supplierLoggedIn = localStorage.getItem('supplierId')
            if (!supplierLoggedIn) {
                toast.error("Something went wrong with loggedIn Credentials.Please login again.")
            } else {
                if (supplierLoggedIn != response.data.supplierId._id) {
                    setIsValidUser(false);
                }
            }

            setLoading(false);
        }
        catch (err) {
            console.log('err', err)
            setLoading(false);
            toast.error("Something went wrong")
        }

    }


    const handleDeclineRFQClick = async () => {
        try {

            if (window.location.host === 'sc.dainsta.com') {
                window?.dataLayer?.push({
                    event: 'declineQuotation',
                    userId: userId,
                    rfqRefId: selectedRFQ.supplierRFQRefId,
                    referenceId: email?.split('@')[0] + email?.split('@')[1]?.split(".")[0],
                })
            }
            const userResponse = confirm("Are you sure you want to decline this quotation?")
            if (userResponse) {
                let data = {
                    rfqId: selectedRFQ._id,
                    isDeclined: true,
                    declineReason: selectedRFQ.declineReason,
                    declineDescription: selectedRFQ.declineDescription,
                }

                let response = await handleDeclineRFQ(data, loggedInUserToken);
                if (response.status) {
                    toast.success(response.message);
                    setRefresh(refresh + 1)
                    navigate('/my-orders?activeTab=pending-for-quotation')
                } else {
                    toast.error(response.message)
                }

            }
        } catch (err) {
            console.log('err', err)
        }
    }

    const handleItemNotesChage = (event, index) => {
        let localPartsData = [...selectedRFQ.partsData];
        localPartsData[index].notes = event.target.value;

        setSelectedRFQ({ ...selectedRFQ, partsData: localPartsData })
    }



    const handleItemPriceChange = (event, index) => {
        let localPartsData = [...selectedRFQ.partsData];
        localPartsData[index].price = event.target.value;
        let totalPrice = localPartsData?.reduce((acc, item) => {
            return acc + (item.price * item.qty);
        }, 0);

        setSelectedRFQ({ ...selectedRFQ, partsData: localPartsData, price: totalPrice })
    }

    const validateRFQData = () => {
        let isDataValid = true;
        let isPriceAvailable = false;

        for (let i = 0; i < selectedRFQ.partsData.length; i++) {
            if (selectedRFQ.partsData[i].price > 0) {
                isPriceAvailable = true;
                break;
            }
        }


        if (isPriceAvailable) {
            isDataValid = true;
        } else {
            isDataValid = false;
        }

        if (!selectedRFQ.leadTime) {
            isDataValid = false;
        }

        return isDataValid;
    }

    const handleSubmitQuote = async () => {
        try {
            const isValidData = validateRFQData();
            if (isValidData) {
                let response = await submitRFQ(selectedRFQ, loggedInUserToken);
                if (response.status) {
                    toast.success(response.message);
                    if (activeTab) {
                        navigate(`/my-orders?activeTab=${activeTab}`)
                    } else {
                        navigate(`/my-orders`)
                    }

                    setRefresh(refresh + 1)
                } else {
                    toast.error(response.message);
                }
            } else {
                toast.error('Item price and delivery date are required field.')
                return;
            }
        }
        catch (err) {
            console.log('err', err)
        }
    }

    const handleLeadTimeChange = (e) => {
        setSelectedRFQ({ ...selectedRFQ, leadTime: e.target.value })
    }

    const showDrawer = () => {
        setOpen(true);
        if (window.location.host === 'sc.dainsta.com') {
            window?.dataLayer?.push({
                event: 'chatOpen',
                userId: userId,
                chatRefId: selectedRFQ.supplierRFQRefId,
                referenceId: email?.split('@')[0] + email?.split('@')[1]?.split(".")[0],
            })
        }
        setSelectedChatRefId(selectedRFQ.supplierRFQRefId)
    };

    const onClose = () => {
        setOpen(false);
        setSelectedChatRefId(null);
    };

    const handleUploadRFQDocument = async (e) => {
        try {
            let rfqDocument = e.target.files[0];
            let formData = new FormData();
            formData.append('rfqId', selectedRFQ._id);
            formData.append('rfqDocument', rfqDocument);

            const uploadRFQDocResponse = await uploadRFQDocument(loggedInUserToken, formData);
            if (uploadRFQDocResponse.status) {
                toast.success("Document Uploaded Succesfully");
                setSelectedRFQ({ ...selectedRFQ, rfqDocument: uploadRFQDocResponse?.data?.rfqDocument });
            }
        }
        catch (err) {
            console.log("err", err)
        }
    }

    const handleRFQDocumentDelete = async () => {
        try {
            const deleteDocResponse = await deleteRFQDocument(loggedInUserToken, selectedRFQ._id);
            if (deleteDocResponse.data.status) {
                setSelectedRFQ({ ...selectedRFQ, rfqDocument: null });
            }
        } catch (err) {
            console.log('err', err);
        }
    }

    const RedirectComponent = () => {
        const [countdown, setCountdown] = useState(3);

        useEffect(() => {
            const timer = setTimeout(() => {
                navigate('/my-orders');
            }, countdown * 1000);

            return () => clearTimeout(timer);

        }, [countdown, navigate]);

        useEffect(() => {
            if (countdown > 0) {
                const countdownTimer = setInterval(() => {
                    setCountdown(prevCountdown => prevCountdown - 1);
                }, 1000);

                return () => clearInterval(countdownTimer);
            }
        }, [countdown]);

        return <div>Redirecting in {countdown} seconds...</div>;
    };


    return (
        <div className="content-wrapper">
            <Chat RefId={selectedRFQ.supplierRFQRefId || id} open={open} onDrawerClose={onClose} />
            {selectedRFQ !== 'Under Review' && <Modal
                size="lg"
                dialogClassName="qoute-version-modal"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showDeclineModal}
                onHide={() => setShowDeclineModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className='text-2xl font-bold'>
                        Decline Quotation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="issue-description-div">
                        <div>
                            <h6>Select a reason to decline</h6>
                            <select style={{ width: '40%', color: '#333333' }} className='border outline-none  p-1' defaultValue={selectedRFQ.declineReason} onChange={(e) => setSelectedRFQ({ ...selectedRFQ, declineReason: e.target.value })}>
                                <option value="Capacity constraints">Capacity constraints</option>
                                <option value="Not feasible">Not feasible</option>
                                <option value="Low order quantity">Low order quantity</option>
                                <option value="Materials issues">Materials issues</option>
                                <option value="Capability issues">Capability issues</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                        <br />
                        <div className="issue-description">
                            <h6>Description:</h6>
                            <textarea className='border p-2 outline-none' placeholder="Write description here" value={selectedRFQ.declineDescription} onChange={(e) => setSelectedRFQ({ ...selectedRFQ, declineDescription: e.target.value })} />
                        </div>
                    </div>
                    <div style={{ color: '#8b8b8b' }}>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='white-btn' style={{ color: 'red', fontWeight: '500' }} onClick={handleDeclineRFQClick}>Decline</button>
                    <button className="white-btn" style={{ backgroundColor: '#2b96dc', color: '#fff' }} onClick={() => setShowDeclineModal(false)}>Close</button>
                </Modal.Footer>
            </Modal>}

            <Modal
                size="lg"
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
                centered
                show={showReviewQuoteModal}
                onHide={() => setShowReviewQuoteModal(false)}
            >
                <Modal.Header closeButton >
                    <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '15px' }}>
                        Review Quotation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="version-tabs" style={{ overflowX: 'auto' }}>
                        <table className="qoute-version-table">
                            <thead>
                                <tr className='heading-row'>
                                    <th scope="col">File Name</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Part Notes</th>
                                    <th scope="col">Notes</th>
                                    <th scope="col">Unit Price</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    selectedRFQ?.partsData?.length > 0 && selectedRFQ.partsData.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className='min-w-max border'>
                                                    <div className="prd-thumb downloadables" style={{ color: 'dodgerblue' }}>
                                                        <p style={{ color: "dodgerblue" }} className='flex justify-start gap-x-2 '>
                                                            <span className='min-w-max'>{item.selectedPartFile ? item?.selectedPartFile?.originalname : 'No File Uploaded'}</span>

                                                            {item.selectedPartFile && <span style={{ cursor: 'pointer' }} onClick={(e) => {
                                                                let url = `${process.env.REACT_APP_API_ENDPOINT}/${item.selectedPartFile.path}`;
                                                                download(item?.selectedPartFile?.originalname, url)
                                                            }
                                                            }>
                                                                <DownloadIcon />
                                                            </span>}
                                                        </p>
                                                    </div>
                                                </td>
                                                <td style={{ width: '240px' }}>
                                                    {
                                                        selectedRFQ?.rfqId?.selectedProcess >= 3 ?
                                                            <>
                                                                {item.description}
                                                            </>
                                                            :
                                                            <>
                                                                <ul>
                                                                    {item?.description}
                                                                    {item?.materialType ? <li>{item?.materialType}</li> : ""}
                                                                    {item?.subMaterial ? <li>{item?.subMaterial}</li> : ""}
                                                                    {item?.surfaceFinish ? <li>{item?.surfaceFinish}</li> : ""}
                                                                    {item?.surfaceTreatment ? <li>{item?.surfaceTreatment}</li> : ""}
                                                                    {item?.tolerance ? <li>{item?.tolerance}</li> : ""}
                                                                    {item?.partMarking ? <li>{item?.partMarking}</li> : ""}
                                                                    {item?.noOfThread ? <li>{item?.noOfThread}</li> : ""}
                                                                </ul>
                                                            </>
                                                    }
                                                </td>
                                                <td style={{ maxWidth: '240px' }}>
                                                    <p>{item?.partNotes.length > 200 ? item?.partNotes.slice(0, 200) + "..." : item.partNotes}</p>
                                                </td>
                                                <td style={{ maxWidth: '240px' }}>
                                                    <p>{item?.notes.length > 200 ? item?.notes.slice(0, 200) + "..." : item.notes}</p>
                                                </td>
                                                <td>
                                                    <p> <CurrencyFormat amount={Number(item?.price).toFixed(2)} /></p>
                                                </td>
                                                <td>
                                                    <p className="amt">{item?.qty}</p>{" "}
                                                </td>
                                                <td>
                                                    {" "}
                                                    <div className="amt">
                                                        <p
                                                            className="un-fld"
                                                        >
                                                            €{" "}  <CurrencyFormat amount={Number(item.qty * item.price).toFixed(2)} />
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }} className='border '>
                            <div className="total-amount-order" style={{ padding: '10px 10px' }}>
                                <h6 className="order-price">
                                    Lead Time (in Days) :{selectedRFQ.leadTime + " days"}
                                </h6>
                            </div>
                            <div className="total-amount-order" style={{ padding: '10px 10px' }}>
                                <h6 className="order-price">
                                    Total : €  {selectedRFQ.price ? <CurrencyFormat amount={Number(selectedRFQ.price).toFixed(2)} /> : '0'}
                                </h6>
                            </div>
                        </div>

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='white-btn' style={{ color: 'red', fontWeight: '500' }} onClick={() => setShowReviewQuoteModal(false)}>Edit</button>
                    <button className="white-btn" style={{ backgroundColor: '#2b96dc', color: '#fff' }} onClick={handleSubmitQuote}>Submit Quotation</button>
                </Modal.Footer>
            </Modal>

            <Modal
                size="lg"
                dialogClassName="qoute-version-modal"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={showRedirectModal}
                onHide={() => {
                    navigate(`/my-orders`)
                    setShowRedirectModal(false);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" style={{ fontSize: '15px' }}>
                        Quotation is already processed.
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <h6>Quotation for this reference Id is already processed.</h6>
                            <RedirectComponent />
                        </div>
                        <br />

                    </div>
                    <div style={{ color: '#8b8b8b' }}>
                    </div>
                </Modal.Body>
            </Modal>








            {isValidUser && !loading ?
                <>
                    <div className="intro-bar-rfq">
                        <div className="int-left-rfq" >
                            <div className='left-item' style={{ marginRight: '40px', cursor: 'pointer' }} onClick={() => navigate(-1)}>
                                <img src={backImg} height='15px' />
                            </div>

                            <div className='left-item'>
                                <p className='p-header'>
                                    RFQ ID : {selectedRFQ.supplierRFQRefId}
                                </p>
                                <p className={
                                    selectedRFQ.status == 'Pending for Quotation' ? 'pending-for-quotation'
                                        : selectedRFQ.status == 'Under Review' ? 'under-review'
                                            : selectedRFQ.status == 'Unapproved' ? 'unapproved-quotes'
                                                : ''
                                }
                                >{selectedRFQ.status}</p>
                            </div>

                            <div className='left-item'>
                                <p className='p-header'>
                                    REQUESTED DATE
                                </p>
                                <p>{moment(selectedRFQ.receivedDate).format('DD MMM YYYY')}</p>
                            </div>

                        </div>
                        <div className="int-right-rfq">
                            {selectedRFQ.status !== 'Under Review' && <div className='right-item' onClick={() => setShowDeclineModal(true)}>
                                <button className='white-btn' style={{ color: 'red', fontWeight: '500', marginRight: '0px', width: '177px', padding: '10px' }}>Decline Quotation</button>
                            </div>}
                            {selectedRFQ.status == 'Pending for Quotation' ?
                                <>
                                    <div className='right-item'>
                                        <button
                                            className='chat-btn'
                                            style={{ color: 'white', fontWeight: '500', backgroundColor: '#00c389' }}
                                            onClick={() => {
                                                const isValidData = validateRFQData();
                                                if (isValidData) {
                                                    if (window.location.host === 'sc.dainsta.com') {
                                                        window?.dataLayer?.push({
                                                            event: 'submitQuotation',
                                                            userId: userId,
                                                            rfqRefId: selectedRFQ.supplierRFQRefId,
                                                            referenceId: email?.split('@')[0] + email?.split('@')[1]?.split(".")[0],
                                                        })
                                                    }
                                                    setShowReviewQuoteModal(true)
                                                } else {
                                                    toast.error('Item price and delivery date are required field.')
                                                }
                                            }}
                                        >
                                            Submit Quotation
                                        </button>
                                    </div>
                                </>
                                :
                                <>
                                </>
                            }

                            <div className='right-item'>
                                <button className=' px-2  py-2 bg-primaryColor h-10 rounded flex items-center justify-center ' onClick={showDrawer}>
                                    <ChatButton color={'white'} RefId={selectedRFQ.supplierRFQRefId} showDrawer={showDrawer} additionalClasses={'text-white text-sm h-10'} />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard-holder ">
                        <div className="lg-container -translate-y-10">
                            {/* <Chat RefId={RefId} open={open} onDrawerClose={onClose} /> */}
                            <div className="common-bx">
                                <div className={selectedRFQ.status == 'Under Review' ? "process-bar-bx green-line" : "process-bar-bx grey-line"}>
                                    <span className="process-ico green-fill">
                                        <img src={settingw} />
                                    </span>
                                    <div style={{ maxWidth: '500px', wordWrap: 'break-word', wordBreak: 'break-all', whiteSpace: 'normal', position: 'absolute', right: '150px' }}>
                                        <span className="text" style={{ color: '#000', fontSize: '14px', fontWeight: 'bolder' }}>Project Name</span>
                                        <div className="name" style={{ color: '#000', fontSize: '14px' }}>{selectedRFQ?.rfqId?.projectName || "Not Found"}</div>
                                    </div>
                                    <h5>Requirements</h5>
                                    <p style={{ color: '#333333', fontSize: '12px' }} >{moment(selectedRFQ.createdAt).format('DD MMM YYYY')}</p>

                                    <h6 className="box-in-quote-version" style={{ color: '#333333' }}>
                                        MFG. Process : {selectedRFQ?.rfqId?.selectedProcess ? processType[selectedRFQ?.rfqId?.selectedProcess - 1].name : null}
                                    </h6>

                                    <div className="version-tabs" style={{ overflowX: 'auto' }}>
                                        <table className="qoute-version-table">
                                            <thead>
                                                <tr className='heading-row'>
                                                    <th scope="col">Part Name</th>
                                                    <th scope="col">Attachment 1</th>
                                                    <th scope="col">Attachment 2</th>
                                                    <th scope="col">Description</th>
                                                    <th scope="col">Part Notes</th>
                                                    <th scope="col">Notes</th>
                                                    <th scope="col">Unit Price</th>
                                                    <th scope="col">Qty</th>
                                                    <th scope="col">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    selectedRFQ?.partsData?.length > 0 && selectedRFQ.partsData.map((item, index) => {
                                                        console.log(item?.selected3DPartFile);
                                                        return (
                                                            <tr key={index}>
                                                                <td style={{ minWidth: '80px' }}>
                                                                    <p >{item?.partName ? item?.partName : 'Not found'}</p>
                                                                </td>
                                                                <td style={{ wordWrap: 'break-word', wordBreak: 'break-all', whiteSpace: 'normal', minWidth: '120px' }}>
                                                                    <div className="prd-thumb downloadables" style={{ color: 'dodgerblue' }}>
                                                                        <p style={{ color: "dodgerblue" }}>
                                                                            {item.selectedPartFile ? <div className='inline-block'>
                                                                                <span>{item?.selectedPartFile?.originalname}</span>
                                                                                <span style={{ cursor: 'pointer' }} onClick={(e) => {
                                                                                    let url = `${process.env.REACT_APP_API_ENDPOINT}/${item.selectedPartFile.path}`;
                                                                                    download(item?.selectedPartFile?.originalname, url)
                                                                                }
                                                                                }>
                                                                                    <DownloadIcon additionalClass={'inline-block '} />
                                                                                </span>
                                                                            </div> : 'No File Uploaded'}

                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td style={{ wordWrap: 'break-word', wordBreak: 'break-all', whiteSpace: 'normal', minWidth: '120px' }}>
                                                                    <div className="prd-thumb downloadables" style={{ color: 'dodgerblue' }}>
                                                                        <p style={{ color: "dodgerblue" }}>
                                                                            {item.selected3DPartFile ?
                                                                                <div className='inline-block' onClick={(e) => {
                                                                                    let url = `${process.env.REACT_APP_API_ENDPOINT}/${item.selected3DPartFile.path}`;
                                                                                    download(item?.selected3DPartFile?.originalname, url)
                                                                                }
                                                                                }>
                                                                                    <span>{item?.selected3DPartFile?.originalname}</span>
                                                                                    <span style={{ cursor: 'pointer' }} >
                                                                                    </span>
                                                                                    <DownloadIcon additionalClass={'inline-block '} />

                                                                                </div> : 'No File Uploaded'}

                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td style={{ minWidth: '250px' }}>
                                                                    {
                                                                        selectedRFQ?.rfqId?.selectedProcess >= 3 ?
                                                                            <>
                                                                                {item.description}
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <ul>
                                                                                    {item?.description}
                                                                                    {item?.materialType ? <li>{item?.materialType}</li> : ""}
                                                                                    {item?.subMaterial ? <li>{item?.subMaterial}</li> : ""}
                                                                                    {item?.surfaceFinish ? <li>{item?.surfaceFinish}</li> : ""}
                                                                                    {item?.surfaceTreatment ? <li>{item?.surfaceTreatment}</li> : ""}
                                                                                    {item?.tolerance ? <li>{item?.tolerance}</li> : ""}
                                                                                    {item?.partMarking ? <li>{item?.partMarking}</li> : ""}
                                                                                    {item?.noOfThread ? <li>{item?.noOfThread}</li> : ""}
                                                                                </ul>
                                                                            </>
                                                                    }
                                                                </td>
                                                                <td className='border' style={{ minWidth: '150px' }}>
                                                                    <p>{item?.partNotes}</p>
                                                                </td>
                                                                <td style={{ minWidth: '300px' }}>
                                                                    <textarea
                                                                        className='border p-1'
                                                                        placeholder='Enter notes here'
                                                                        style={{ width: '100%', height: '100px' }}
                                                                        value={item?.notes}
                                                                        onChange={(e) => handleItemNotesChage(e, index)}
                                                                        maxLength={200}
                                                                        disabled={selectedRFQ.status == 'Pending for Quotation' ? false : true}
                                                                    />
                                                                </td>
                                                                <td >
                                                                    <div className='flex justify-center gap-x-2'>
                                                                        <span className='mt-1'>€</span>
                                                                        <input
                                                                            className='border grow p-1 w-full'
                                                                            placeholder="Enter price"
                                                                            value={item.price ? item.price : ""}
                                                                            style={{ width: '60px', marginBottom: '15px' }}
                                                                            onWheel={numberInputOnWheelPreventChange}
                                                                            onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                                            onChange={(e) => { handleItemPriceChange(e, index) }}
                                                                            disabled={selectedRFQ.status == 'Pending for Quotation' ? false : true}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <p className="amt">{item?.qty}</p>{" "}
                                                                </td>
                                                                <td style={{ minWidth: '90px' }}>
                                                                    <div className="amt">
                                                                        <p
                                                                            className="un-fld"
                                                                        >
                                                                            {"€ "} <CurrencyFormat amount={Number(item.qty * item.price).toFixed(2)} />
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div>
                                        <p className='text-[18px] font-medium ' >Quotation document</p>
                                        <div className="col quality-doc-div-po  " >
                                            {(selectedRFQ?.rfqDocument?.filename) ?
                                                <>
                                                    <div className='flex gap-x-2 items-center'>
                                                        <a
                                                            className="downloadables flex gap-x-2 items-center !text-primaryColor"
                                                            onClick={() => download(selectedRFQ.rfqDocument.originalname, `${process.env.REACT_APP_API_ENDPOINT}/${selectedRFQ.rfqDocument.path}`)}
                                                            download={selectedRFQ.rfqDocument.filename}

                                                        >
                                                            <span>{selectedRFQ.rfqDocument.originalname}</span>
                                                            <DownloadIcon />
                                                        </a>
                                                        <div onClick={handleRFQDocumentDelete}>
                                                            <DeleteIcon additionalClasses={'text-red-500'} />
                                                        </div>
                                                    </div>
                                                </>
                                                : <>
                                                    <div>
                                                        <label className="upload-doc-btn" htmlFor={`uploadDoc`}>Upload Document</label>
                                                        <Form.Control
                                                            id={`uploadDoc`}
                                                            className="quality-doc-item-input"
                                                            type="file"
                                                            onChange={(e) => {
                                                                let filesForCheck = Array.from(e.target.files);
                                                                let isAllFilesValid = true;
                                                                filesForCheck.forEach(file => {
                                                                    if (file.size > 10000000) {
                                                                        isAllFilesValid = false;
                                                                    }
                                                                })

                                                                if (!isAllFilesValid) {
                                                                    toast.error("File size should be less than 10 MB");
                                                                    return;
                                                                }
                                                                handleUploadRFQDocument(e)
                                                            }}
                                                            accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                                                        />
                                                    </div>
                                                </>
                                            }

                                        </div>

                                    </div>

                                    <div className='mt-3  flex justify-around '>
                                        <div className='grow'>
                                            <p style={{ color: '#333333', fontSize: '14px', fontWeight: '500' }} >Please note you will need to provide following documents: </p>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '-10px' }} >
                                                <div className="apply-check" style={{ marginRight: '10px' }} >
                                                    <input
                                                        type="checkbox"
                                                        id="sign-check-cc"
                                                        name="checkbox"
                                                        value={selectedRFQ?.rfqId?.isConformanceCertificateRequested}
                                                        checked={selectedRFQ?.rfqId?.isConformanceCertificateRequested}
                                                        disabled
                                                    />
                                                    <label htmlFor="sign-check-cc" style={{ fontSize: '12px' }}>Certificate of conformance</label>
                                                </div>
                                                <div className="apply-check" style={{ marginRight: '10px' }}>
                                                    <input
                                                        type="checkbox"
                                                        id="sign-check-dr"
                                                        name="checkbox"
                                                        value={selectedRFQ?.rfqId?.isDimensionalReportRequested}
                                                        checked={selectedRFQ?.rfqId?.isDimensionalReportRequested}
                                                        disabled
                                                    />
                                                    <label htmlFor="sign-check-dr" style={{ fontSize: '12px' }}>Dimensional Inspection Report</label>
                                                </div>

                                                <div className="apply-check flex items-center justify-center gap-x-2 " style={{ marginRight: '10px' }} >
                                                    <input
                                                        type="checkbox"
                                                        id="sign-check-qr"
                                                        name="checkbox"
                                                        value={selectedRFQ?.rfqId?.isQrTrackingRequested}
                                                        checked={selectedRFQ?.rfqId?.isQrTrackingRequested}
                                                        disabled
                                                    />
                                                    <label htmlFor="sign-check-qr" style={{ fontSize: '12px', display: 'inline-block' }} >QR tracking</label>
                                                    <HoverInfo content="QR code etching will be required on parts. If the order is allocated a QR file will be available to download at purchase order stage." />
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className='flex items-center gap-x-2 justify-center '>
                                                <div className='grow'>
                                                    <p style={{ color: '#333333', fontSize: '14px', fontWeight: '500' }} >Lead Time (in Days):</p>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '-10px' }}>
                                                        <div className="apply-check" style={{ marginRight: '80px' }} >
                                                            <input
                                                                className='border p-1'
                                                                type="number"
                                                                style={{ fontSize: '13px' }}
                                                                onWheel={numberInputOnWheelPreventChange}
                                                                onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                                onChange={handleLeadTimeChange}
                                                                disabled={selectedRFQ.status == 'Pending for Quotation' ? false : true}
                                                                placeholder='Lead time in Days'
                                                                value={selectedRFQ.leadTime ? selectedRFQ.leadTime : ''}
                                                            />
                                                            {selectedRFQ.leadTime ?
                                                                <div style={{ fontSize: '13px' }}>
                                                                    ( {Math.floor(selectedRFQ.leadTime / 7) + "-" + (Math.floor(selectedRFQ.leadTime / 7) + 1) + " weeks"} )
                                                                </div>
                                                                :
                                                                <>
                                                                </>
                                                            }

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="total-amount-order  grow w-[180px]  " >
                                                    <h6
                                                        className="order-price h-10 "

                                                    >
                                                        <div>Sub Total :  </div>
                                                        <div className='mt-2'>€ {
                                                            selectedRFQ.price ? <CurrencyFormat amount={Number(selectedRFQ.price).toFixed(2)} /> : '0'
                                                        }</div>


                                                    </h6>
                                                </div>
                                            </div>
                                            <div >

                                                {selectedRFQ.status == 'Pending for Quotation' &&
                                                    <div >
                                                        <button
                                                            className=' px-3 py-2 mt-4  float-end rounded flex justify-center items-center'
                                                            style={{ color: 'white', fontWeight: '500', backgroundColor: '#00c389', width: "100%" }}
                                                            onClick={() => {
                                                                const isValidData = validateRFQData();
                                                                if (isValidData) {
                                                                    if (window.location.host === 'sc.dainsta.com') {
                                                                        window?.dataLayer?.push({
                                                                            event: 'submitQuotation',
                                                                            userId: userId,
                                                                            rfqRefId: selectedRFQ.supplierRFQRefId,
                                                                            referenceId: email?.split('@')[0] + email?.split('@')[1]?.split(".")[0],
                                                                        })
                                                                    }
                                                                    setShowReviewQuoteModal(true)
                                                                } else {
                                                                    toast.error('Item price and delivery date are required field.')
                                                                }
                                                            }}
                                                        >
                                                            Submit Quotation
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="order-pay-box">
                                    <span className="order-ico">
                                        <img src={docGrey} />
                                    </span>
                                    <h5>Order Details</h5>
                                    {selectedRFQ.status == 'Under Review' ?
                                        <div style={{ background: '#DEE2E6', padding: '20px 30px', borderRadius: '5px', fontSize: '14px' }}>
                                            <h6>Your quote is under review.</h6>
                                            <p>Your quotation has been submitted successfully. If your quote is accepted, we will send you a Purchase Order</p>
                                        </div>
                                        :
                                        <></>}


                                </div>
                            </div>
                        </div>
                    </div >
                </>
                :
                loading ?
                    <>
                        <Loading />

                    </>
                    : <>
                        <div className="dashboard-holder">
                            <div className="sm-container">

                                <div className="dashboard-option">
                                    <div className="dash-left">
                                        <div className="ds-heading">
                                            <Link to="/dashboard">
                                                <p className="req-quote-btn">Go To DashBoard  </p>
                                            </Link>
                                        </div>
                                    </div>

                                    <div style={{ textAlign: 'center' }}>
                                        <h2>Quotation information is not available</h2>
                                        <br />
                                        <p>Your dont have access to this quote version details.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }

        </div >
    );
}

export default RFQDetails;
